import { ProposalMove } from "work/proposals/__constants/proposal-lifecycle";
import Proposal from "work/proposals/proposal";

/**
 * What a row on the proposals list is tinted for: what the proposal needs from the reader.
 *
 * The move chips above the table carry the same colours, so they explain the tints and the page
 * needs no legend (#6473). Their move has no tint: it asks nothing of the reader.
 */
export enum ProposalTableContext {
  YourMove = "your-move",
  YourReview = "your-review",
  NoAction = "no-action",
}

/**
 * The tint of `proposal`'s row, read from `readerMove`.
 *
 * The server reads that from the reader's boxes by the rule the move chips filter with
 * (`Work.Proposals.ProposalMoves`), so every orange row is one the Your move chip lists, and every
 * blue row one the Your review chip lists. Deriving it here from the available actions, as this
 * once did, let a tint and its chip disagree.
 */
export function getProposalTableContext(proposal: Proposal): ProposalTableContext {
  if (proposal.readerMove === ProposalMove.YourMove) return ProposalTableContext.YourMove;
  if (proposal.readerMove === ProposalMove.YourReview) return ProposalTableContext.YourReview;
  return ProposalTableContext.NoAction;
}

/** The tint a move chip carries as its swatch, so the chip names the rows it lists. */
export function proposalTableContextOfMove(move: ProposalMove): ProposalTableContext {
  if (move === ProposalMove.YourMove) return ProposalTableContext.YourMove;
  if (move === ProposalMove.YourReview) return ProposalTableContext.YourReview;
  return ProposalTableContext.NoAction;
}
